
import { Component } from 'vue-property-decorator';
import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';
import MenuGroupLimitAddEdit from './MenuGroupLimitAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class MenuGroupLimitItem {
  id: string = '';
  outletCode: string = '';
  menuGroupCode: string = '';
  orderType: string = '';
}

@Component({
  components: {
    editor: MenuGroupLimitAddEdit
  }
})
export default class MenuGroupLimitList extends RemoteDataTable<
  MenuGroupLimitItem
  > {
  public pageTitle: string = 'Menu Group Limit List';

  public newButtonText: string = 'New MenuGroupLimit';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({ key: 'outletCode', label: 'Outlet Code' }),
    new RemoteDataField({ key: 'menuGroupCode', label: 'Menu Group Code' }),
    new RemoteDataField({ key: 'orderType', label: 'Order Type' })
  ];
  // to get page data
  get items(): MenuGroupLimitItem[] {
    return this.$store.getters.GetAllMenuGroupLimit;
  }
  get paging(): MenuGroupLimitItem[] {
    return this.$store.getters.PagingMenuGroupLimit;
  }
  get sorting(): MenuGroupLimitItem[] {
    return this.$store.getters.SortingMenuGroupLimit;
  }
  get filtering(): MenuGroupLimitItem[] {
    return this.$store.getters.FilteringMenuGroupLimit;
  }

  resetSorting() {
    this.sortingChanged({ sortBy: '', sortDesc: '' });
  }
  resetFilter() {
    this.filterChanged(true);
  }
  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingMenuGroupLimit', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }
  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringMenuGroupLimit', {
      isResetFilter: isResetFilter
    });
  }
  reload(id = null) {
    if (id === 1) {
      this.$store.state.menuGroupLimit.pagingMenuGroupLimit.page = 1;
    }
    this.$store.dispatch('GetAllMenuGroupLimit');
  }
  dialogClosed() {
    this.selectedItem = null;
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteMenuGroupLimit', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.menuGroupLimit.pagingMenuGroupLimit.size = page;
    this.$store.dispatch('GetAllMenuGroupLimit');
  }
}
